import { Input, InputNumber } from 'antd';
import { useState } from 'react';
import { putServiceBatchApproval } from '../../../api';
import { messageError, messageSuccess } from '../../../components/message';
import { ModalWrap } from '../../../components/modal-wrap';
import getFormatMessage from '../../../locales/get-format-message';
import {
  CommonStatusStep,
  IAPIServicesApproveItem,
} from '../../../model/api-modules';
import {
  GameEnvType,
  IServiceBatchApproval,
} from '../../../model/api-modules/env';
import { IServicesApproveItem } from '../../../model/service';
import styles from './index.module.scss';
// import { fetchAdminEnvList } from '../../../api/admin/game';
// import { wrapRequestArea } from '../../../lib/http/lib';

interface IProps {
  readonly site?: string;
  readonly isFeeEnabled: boolean;
  readonly singleService?: IServicesApproveItem;
  readonly batchServices?: ReadonlyArray<IServicesApproveItem>;
  readonly onSuccess: () => void;
  readonly onCancel: () => void;
  readonly selectedRowKey: number | undefined;
  readonly serviceList: IAPIServicesApproveItem[];
}

export const ServiceResolveModal = (props: IProps) => {
  const { isFeeEnabled } = props;
  const { singleService, batchServices = [] } = props;

  const [loading, setLoading] = useState<boolean>(false);
  const [expectedAmount, setExpectedAmount] = useState<{
    [id: number]: number | null;
  }>({});
  const [gauthServiceType, setGauthServiceType] = useState<string>('');
  const [gauthServiceTypeName, setGauthServiceTypeName] = useState<string>('');

  const onClose = () => {
    props.onCancel();
  };

  const getIsLiveVoiceService = (service: IServicesApproveItem) => {
    return (
      isFeeEnabled &&
      service.EnvItem?.Type === GameEnvType.Live &&
      /^voice\s+chat$/i.test(service.ServiceName || '')
    );
  };

  const selectedServices = singleService ? [singleService] : batchServices;

  const commitApply = async () => {
    const isMissExpectedAmount = selectedServices.some((service) => {
      return (
        getIsLiveVoiceService(service) &&
        typeof expectedAmount[service.ServiceID] !== 'number'
      );
    });
    if (isMissExpectedAmount) {
      messageError('请输入冻结金额');
      return false;
    }
    const serviceItem = props.serviceList.find(
      (item) => item.id === props.selectedRowKey
    );
    if (serviceItem) {
      setLoading(true);
      // let envType = '';
      // const result = await wrapRequestArea(
      //   () => fetchAdminEnvList(serviceItem.GameID),
      //   site
      // );
      // if (result) {
      //   const envItem = result.find((item) => item.id === serviceItem.EnvID);
      //   envType = envItem?.Type || '';
      // }
      const envType = serviceItem.EnvItem?.Type || '';
      // const failedIds: number[] = [];
      for (const service of selectedServices) {
        // for (const approveID of service.relatedApproveIds || []) {
        const body: IServiceBatchApproval = {
          recordIds: service.relatedApproveIds || [],
          status: CommonStatusStep.Resolve,
          expectedAmount: expectedAmount[service.ServiceID] || 0,
          envType,
        };
        if (selectedServices[0].ServiceName === 'Store') {
          body.gauthServiceType = gauthServiceType;
          body.gauthServiceTypeNme = gauthServiceTypeName;
        }
        const res = await putServiceBatchApproval(body);
        if (res?.code === 0) {
          messageSuccess(getFormatMessage('operation_success'));
        } else if (res?.code === 101868) {
          if (res?.data && res?.data?.code && res?.data?.msg) {
            messageError(
              getFormatMessage(
                `code: ${res?.data?.code}, msg: ${res?.data?.msg}`
              )
            );
          } else {
            messageError(getFormatMessage('operation_failed'));
          }
        } else {
          messageError(getFormatMessage('operation_failed'));
        }
        // if (!res) {
        //   failedIds.push(approveID);
        // }
        // }
      }
      setLoading(false);
      // if (failedIds.length === 0) {
      //   messageSuccess(getFormatMessage('operation_success'));
      // } else {
      //   const failedIdsString = failedIds.join(', ');
      //   messageError(
      //     getFormatMessage('operation_failed_ids', {
      //       params: {
      //         failedIdsString,
      //       },
      //     })
      //   );
      // }
      props.onSuccess();
      return true;
    }
    return false;
  };

  const renderGauth = (service: IServicesApproveItem) => {
    if (service.ServiceName === 'Store') {
      return (
        <>
          <div>
            <label>
              业务编码<span style={{ color: 'red' }}>*</span>:{' '}
            </label>
            <Input
              style={{ width: 300 }}
              value={gauthServiceType}
              onChange={(e) => setGauthServiceType(e.target.value)}
            />
          </div>
          <div style={{ marginTop: '4px' }}>
            <label>
              业务编码名称<span style={{ color: 'red' }}>*</span>:{' '}
            </label>
            <Input
              style={{ width: 300 }}
              value={gauthServiceTypeName}
              onChange={(e) => setGauthServiceTypeName(e.target.value)}
            />
          </div>
        </>
      );
    }
    return null;
  };

  return (
    <ModalWrap
      width="580px"
      loading={loading}
      oKText={getFormatMessage('submit')}
      cancelText={getFormatMessage('cancel')}
      title={`${getFormatMessage('confirm_approve')}`}
      onOk={commitApply}
      onClose={onClose}
      okButtonProps={{
        disabled: selectedServices.find(item => item.ServiceName === 'Store') && (!gauthServiceType || !gauthServiceTypeName),
      }}
    >
      <div className={styles.resolveContent}>
        {selectedServices.map((service) => {
          return (
            <>
              <div>
                <label>游戏: </label>
                {service.GameName}
              </div>
              <div>
                <label>环境: </label>
                {service.EnvItem?.Name}
              </div>
              <div>
                <label>服务: </label>
                {service.ServiceName}
              </div>
              <div>
                <label>子服务: </label>
                {service.SubServiceName || service.ServiceName}
              </div>

              <div>
                {getIsLiveVoiceService(service) && (
                  <>
                    <label>冻结金额: </label>
                    <InputNumber
                      size="small"
                      placeholder="请输入冻结金额"
                      min={0}
                      precision={2}
                      value={expectedAmount[service.ServiceID]}
                      onChange={(val) => {
                        setExpectedAmount({
                          ...expectedAmount,
                          [service.ServiceID]: val,
                        });
                      }}
                    />
                  </>
                )}
              </div>
              {renderGauth(service)}
            </>
          );
        })}
      </div>
    </ModalWrap>
  );
};
